<template>
    <div class="equitySetting">
        <div class="closeAccount">
            <div class="title">结算方式</div>
            <div class="text">
                <span class="result">自动结算</span>
                <span class="resultTips">订单完成后立即结算，推广员可提现</span>
            </div>
        </div>
        <div class="selfBuy">
            <div class="title">自购分佣</div>
            <div class="selfBuyBtn">
                <el-radio @click.native="closeOpenShop" v-model="params.issettlebyself" :label="1">开启 <span class="openTips">开启后，推广员购买推广商品，可获得直接推广佣金，推广员的上级邀请人获得间接推广佣金</span></el-radio>
                <br>
                <el-radio @click.native="closeOpenShop" v-model="params.issettlebyself" :label="0">关闭</el-radio>
            </div>
        </div>
        <div class="gradeRule">
            <div class="title">
                等级规则 <i class="el-icon-info"></i>
            </div>
            <div class="ruleList">
                <el-table :data="params.promoterlevelList" style="width: 100%">
                    <el-table-column prop="leveltypeText" label="推广员级别"></el-table-column>
                    <el-table-column prop="upgradeRule" label="升级规则" class-name="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.leveltype === 1">{{scope.row.upgradeRule}}</span>
                            <div class="ruleSetting" v-if="scope.row.leveltype !== 1  && scope.row.edit">
                                <div :class="{'client': true, 'unit': scope.row.totalclientcount.check}">
                                    <el-checkbox v-model="scope.row.totalclientcount.check"></el-checkbox>
                                    <span class="name">累计推广客户</span>
                                    <el-input maxlength="10" v-model.number="scope.row.totalclientcount.num" :disabled="!scope.row.totalclientcount.check">
                                        <template slot="append" class="unit">人</template>
                                    </el-input>
                                </div>
                                    <div :class="{'money': true, 'unit': scope.row.totalordermoney.check}">
                                    <el-checkbox v-model="scope.row.totalordermoney.check"></el-checkbox>
                                    <span class="name">累计推广金额</span>
                                    <el-input maxlength="10" v-model.number="scope.row.totalordermoney.num" :disabled="!scope.row.totalordermoney.check">
                                        <template slot="append">元</template>
                                    </el-input>
                                </div>
                                <div :class="{'invite': true, 'unit': scope.row.totalpromotercount.check}">
                                    <el-checkbox v-model="scope.row.totalpromotercount.check"></el-checkbox>
                                    <span class="name">累计邀请推广员</span>
                                    <el-input maxlength="10" v-model="scope.row.totalpromotercount.num" :disabled="!scope.row.totalpromotercount.check">
                                        <template slot="append">人</template>
                                    </el-input>
                                </div>
                            </div>
                                <div v-if="scope.row.leveltype !== 1  && !scope.row.edit" class="showGeneralize">
                                <div v-if="scope.row.totalclientcount.num"><span class="name">累计推广客户</span><span class="value">{{scope.row.totalclientcount.num}}人</span></div>
                                <div v-if="scope.row.totalordermoney.num"><span class="name">累计推广金额</span><span class="value">{{scope.row.totalordermoney.num}}元</span></div>
                                <div v-if="scope.row.totalpromotercount.num"><span class="name">累计邀请推广员</span><span class="value">{{scope.row.totalpromotercount.num}}人</span></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="diectbrokeragerate" label="默认直接推广佣金比例" class-name="center">
                        <template slot-scope="scope">
                            <div class="directCommission">
                                <span v-show="!scope.row.edit">{{scope.row.diectbrokeragerate}}%</span>
                                <div v-show="scope.row.edit" class="changeCommission">
                                    <el-input maxlength="10" v-model="scope.row.diectbrokeragerate"></el-input>
                                    <span>%</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="secondbrokeragerate" label="默认间接推广佣金比例" class-name="center">
                        <template slot-scope="scope">
                            <div class="indirectCommission">
                                <span v-show="!scope.row.edit">{{scope.row.secondbrokeragerate}}%</span>
                                <div v-show="scope.row.edit" class="changeCommission">
                                    <el-input maxlength="10" v-model="scope.row.secondbrokeragerate"></el-input>
                                    <span>%</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="action" label="操作" class-name="right">
                        <template slot-scope="scope">
                            <div class="action">
                                <span v-show="!scope.row.edit" @click="edit(scope.row)">编辑</span>
                                <span v-show="scope.row.edit" class="confirm" @click="confirmEdit(scope.row)">确定</span>
                                <span v-if="scope.row.edit && scope.row.leveltype !== 3" class="cancel" @click="cancelEdit(scope.row.leveltypeText,scope.row)">取消</span>
                                <span v-if="scope.row.edit && scope.row.leveltype === 3" @click="deleteGrade">删除</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <p class="tips">选择多个升级条件时，需要同时满足才能升级</p>
                <span v-if="params.promoterlevelList.length < 3" class="addGrade" @click="addGrade">增加等级</span>
            </div>
        </div>
        <CommissionOpenClose :way="params.issettlebyself" ref="commissionOpenClose" @setWay="setWay"></CommissionOpenClose>
    </div>
</template>
<script>
import CommissionOpenClose from './equitySetting/commissionOpenClose'
export default {
    name: 'equitySetting',
    data() {
        return {
            params: {
                settletype: 1,
                issettlebyself: 1,
                promoterlevelList: [
                    {
                        configinnerid: '',
                        leveltypeText: '普通推广员',
                        innerid: '',
                        edit: false,
                        leveltype: 1,
                        upgradeRule: '所有推广员默认等级',
                        diectbrokeragerate: 2, // 直接推广佣金比例
                        secondbrokeragerate: 1 // 间接推广佣金比例
                    },
                    {
                        edit: false,
                        innerid: '',
                        leveltypeText: '高级推广员',
                        configinnerid: '',
                        leveltype: 2,
                        totalclientcount : { // 累计推广客户
                            check: false,
                            num: '100' // 客户人数
                        },
                        totalordermoney: {
                            check: false,
                            num: '' // 金额
                            
                        },
                        totalpromotercount: {
                            check: false,
                            num: '' // 邀请推广员
                        },
                        diectbrokeragerate: 4, // 直接推广佣金比例
                        secondbrokeragerate: 3 // 间接推广佣金比例
                    },
                    {
                        edit: false,
                        configinnerid: '',
                        innerid: '',
                        leveltypeText: '超级推广员',
                        leveltype: 3,
                        totalclientcount : { // 累计推广客户
                            check: false,
                            num: 101 // 客户人数
                        },
                        totalordermoney: {
                            check: false,
                            num: '' // 金额
                            
                        },
                        totalpromotercount: {
                            check: false,
                            num: '' // 邀请推广员
                        },
                        diectbrokeragerate: 1, // 直接推广佣金比例
                        secondbrokeragerate: 1 // 间接推广佣金比例
                    }
                ]
            },
            promoterlevelList: [
                {
                    configinnerid: '',
                    leveltypeText: '普通推广员',
                    innerid: '',
                    edit: false,
                    leveltype: 1,
                    upgradeRule: '所有推广员默认等级',
                    diectbrokeragerate: 2, // 直接推广佣金比例
                    secondbrokeragerate: 1 // 间接推广佣金比例
                },
                {
                    edit: false,
                    innerid: '',
                    leveltypeText: '高级推广员',
                    configinnerid: '',
                    leveltype: 2,
                    totalclientcount : { // 累计推广客户
                        check: false,
                        num: '100' // 客户人数
                    },
                    totalordermoney: {
                        check: false,
                        num: '' // 金额
                        
                    },
                    totalpromotercount: {
                        check: false,
                        num: '' // 邀请推广员
                    },
                    diectbrokeragerate: 4, // 直接推广佣金比例
                    secondbrokeragerate: 3 // 间接推广佣金比例
                },
                {
                    edit: false,
                    configinnerid: '',
                    innerid: '',
                    leveltypeText: '超级推广员',
                    leveltype: 3,
                    totalclientcount : { // 累计推广客户
                        check: false,
                        num: 101 // 客户人数
                    },
                    totalordermoney: {
                        check: false,
                        num: '' // 金额
                        
                    },
                    totalpromotercount: {
                        check: false,
                        num: '' // 邀请推广员
                    },
                    diectbrokeragerate: 1, // 直接推广佣金比例
                    secondbrokeragerate: 1 // 间接推广佣金比例
                }
            ],
            originalData: [],
            obj: {
                edit: false,
                configinnerid: '',
                innerid: '',
                leveltypeText: '超级推广员',
                leveltype: 3,
                totalclientcount : { // 累计推广客户
                    check: false,
                    num: 101 // 客户人数
                },
                totalordermoney: {
                    check: false,
                    num: '' // 金额
                    
                },
                totalpromotercount: {
                    check: false,
                    num: '' // 邀请推广员
                },
                diectbrokeragerate: 1, // 直接推广佣金比例
                secondbrokeragerate: 1 // 间接推广佣金比例
            }
        }
    },
    props: ['innerid', 'data'],
    mounted() {
    },
    methods: {
        // 编辑
        edit(row) {
            row.edit = true
            this.originalData = JSON.parse(JSON.stringify(this.params.promoterlevelList))
        },
        // 确定编辑
        confirmEdit(row) {
            row.edit = false
            this.originalData = JSON.parse(JSON.stringify(this.params.promoterlevelList))
            this.params.promoterlevelList.forEach(obj => {
                if (obj.totalclientcount.num > 0) {
                    obj.totalclientcount.check = true
                } else {
                    obj.totalclientcount.check = false
                }
                if (obj.totalordermoney.num > 0) {
                    obj.totalordermoney.check = true
                } else {
                    obj.totalordermoney.check = false
                }
                if (obj.totalpromotercount.num > 0) {
                    obj.totalpromotercount.check = true
                } else {
                    obj.totalpromotercount.check = false
                }
            })
        },
        // 取消编辑
        cancelEdit(leveltypeText, row) {
            this.originalData.forEach((obj1, index) => {
                this.params.promoterlevelList.forEach((obj2, index) => {
                    if (obj1.leveltypeText === leveltypeText && obj2.leveltypeText === leveltypeText) {
                        for (let item in obj1) {
                            obj2[item] = obj1[item]
                        }
                        row.edit = false
                    }
                })
            })
        },
        // 增加等级
        addGrade() {
            this.obj.edit = false
            this.params.promoterlevelList.push(this.obj)
        },
        deleteGrade() {
            this.params.promoterlevelList.pop()
        },
        setWay(v) {
            this.params.issettlebyself = v
        },
        closeOpenShop() {
            this.$refs.commissionOpenClose.dialogVisible = true
        }
    },
    components: {
        CommissionOpenClose
    },
    watch: {
        'data': {
            handler() {
                this.params.promoterlevelList = JSON.parse(JSON.stringify(this.promoterlevelList))
                let arr = JSON.parse(this.data.promoterlevelList)
                if (arr.length === 2) {
                    this.params.promoterlevelList.pop()
                }
                this.params.promoterlevelList.forEach(obj1 => {
                    arr.forEach(obj2 => {
                        if (obj1.leveltype === obj2.leveltype) {
                            obj1.totalclientcount = {
                                check: false,
                                num: obj2.totalclientcount
                            }
                            if (obj1.totalclientcount > 0) {
                                obj1.totalclientcount.check = true
                            }
                            
                            obj1.innerid = obj2.innerid
                            obj1.diectbrokeragerate = obj2.diectbrokeragerate
                            obj1.secondbrokeragerate = obj2.secondbrokeragerate
                            obj1.totalordermoney = {
                                check: false,
                                num: obj2.totalordermoney
                            }
                            if (obj1.totalordermoney > 0) {
                                obj1.totalordermoney.check = true
                            }
                            obj1.totalpromotercount = {
                                check: false,
                                num: obj2.totalpromotercount
                            }
                            if (obj1.totalpromotercount > 0) {
                                obj1.totalpromotercount.check = true
                            }
                        }
                        this.obj.configinnerid = obj2.configinnerid
                        obj1.configinnerid = obj2.configinnerid
                    })
                })
            },
            deep: true
        },
        'params.promoterlevelList': {
            handler(newV) {
                newV.forEach(obj => {
                    if (obj.totalclientcount.num > 0) {
                        obj.totalclientcount.check = true
                    }
                    if (obj.totalordermoney.num > 0) {
                        obj.totalordermoney.check = true
                    }
                    if (obj.totalpromotercount.num > 0) {
                        obj.totalpromotercount.check = true
                    }
                })
            }
        },
        deep: true
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .equitySetting{
        .selfBuy, .closeAccount{
            display: flex;
            margin-top: 20px;
            .title{
                width: 84px;
                margin-right: 40px;
                color: #606266;
            }
            .selfBuyBtn{
                .el-radio{
                    margin-bottom: 15px;
                    .openTips{
                        color: #909399;
                        margin-left: 20px;
                    }
                }
                .el-radio__input.is-checked+.el-radio__label{
                    color: #303133;
                }
            }
            .text{
                .resultTips{
                    color: #909399;
                    margin-left: 20px;
                }
            }
        }
        .gradeRule{
            display: flex;
            margin-top: 20px;
            .title{
                color: #606266;
                margin-right: 40px;
                .el-icon-info{
                    color: #C0C4CC;
                }
            }
            .ruleList{
                width: 1200px;
.ruleSetting{
                    div{
                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;
                        .name{
                            display: inline-block;
                            width: 98px;
                            margin-right: 10px;
                        }
                        .el-input{
                            width: 85px;
                            height: 32px;
                            position: relative;
                            top: 5px;
                            .el-input__inner{
                                border-right: transparent;
                            }
                            .el-input__inner:focus{
                                border-right: 1px solid #56A9FF;
                            }
                            .el-input-group__append{
                                height: 32px;
                                width: 30px;
                                border-left: none;
                                background: #F5F7FA;
                                padding: 0 5px;
                                margin-top: 10px;
                            }
                        }
                        .el-checkbox{
                            margin-right: 10px;
                        }
                    }
                    .unit{
                        .el-input{
                            .el-input-group__append{
                                background: #fff;
                            }
                        }
                    }
                }
                .showGeneralize{
                    .name{
                        display: inline-block;
                        width: 98px;
                        text-align: left
                    }
                    .value{
                        display: inline-block;
                        width: 80px;
                        text-align: right;
                    }
                }
                .directCommission,.indirectCommission{
                    .changeCommission{
                        .el-input{
                            width: 70px;
                            margin-right: 6px;
                        }
                    }
                    
                }
                .action{
                    color: #56A9FF;
                    cursor: pointer;
                    .confirm{
                        margin-right: 20px;
                    }
                }
                .center{
                    text-align: center;
                }
                .right{
                    text-align: right;
                }
                .tips{
                    color: #909399;
                    margin-top: 16px;
                    font-size: 12px;
                }
                .addGrade{
                    color: #56A9FF;
                    cursor: pointer;
                    margin-top: 10px;
                    display: inline-block;
                    font-size: 14px;
                }
            }
        }
    }
</style>